export default __webpack_public_path__ + "static/media/EQUIPEMENT ET MATÉRIEL SCINTIFIQUE.aba833f3.jpg";